export default __webpack_public_path__ + "static/media/book-close.c2cf458f.svg";